import { useCallback, useEffect, useState } from "react";
import { MessagesService } from "../../../../../services/messages";

export const useFetchData = () => {
  const [data, setData] = useState<any>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res = await MessagesService.fetchConversations();

      setData(res);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, setData };
};
